/*
*
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
* 
*/
import { Injectable } from '@angular/core';

// import 'rxjs/Rx';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
// Removed @angular/http import, not needed
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class MasterDataService {
  private masterTabData = new BehaviorSubject<MasterTableData>({ "header": {}, "data": [] });
  masterTableData = this.masterTabData.asObservable();
  private tableAction = new BehaviorSubject<MasterTableAction>({ "action": "", "data": {} });
  masterTableAction = this.tableAction.asObservable();
  private masterTabPagination = new Subject<MasterTablePagination>();
  masterTablePaginationAction = this.masterTabPagination.asObservable();
  constructor(private httpClient: HttpClient) {
  }

  updateMasterTableData(data: MasterTableData) {
    this.masterTabData.next(data);
  }

  triggerTableAction(action: MasterTableAction) {
    //console.log("New Action Triggered ----> ", action);
    this.tableAction.next(action);
  }

  triggerPagination(paginationData: MasterTablePagination) {
    //console.log("New Pagination Triggered ----> ", paginationData);
      this.masterTabPagination.next(paginationData);
  }

  deleteRecord(url, data): any{
    return this.httpClient.post(url,{}).pipe(
    map(
      (res: Response) => {
        return "Record Deleted Successfully";
      }
    ));
    // .catch(
    //   (error: Response) => {
    //     console.log("Error on Calling Delete service : " + JSON.stringify(error));
    //     if(error.headers && error.headers['error'])
          
    //     return Observable.throw(error.statusText);
    //   }
    // );
  }
}

export interface MasterTableData {
  header: Object;
  data: any[];
}

export interface MasterTableAction {
  action: string;
  data: any;
}

export interface MasterTablePagination {
  order: string;
  sortBy: string;
  pageNumber: number;
  pageSize: number;
}


